(function() {
	'use strict';
	angular.module('nasracApp').factory('Nctc', Nctc);

	Nctc.$inject = [ '$resource' ];

	function Nctc($resource) {
		var resourceUrl = 'api/nctc';
		var xlsxContentType = 'application/octet-stream';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'getReportDates' : {
				method : 'GET',
				url : 'api/nctc/reportdates',
				isArray : true
			},

			'download' : {
				method : 'GET',
				url : 'api/nctc/download',
				headers : {
					accept : xlsxContentType
				},
				responseType : 'arraybuffer',
				cache : false,
				transformResponse : function(data) {
					return {
						response : new Blob([ data ], {
							type : xlsxContentType
						})
					};
				}
			},

		});
	}
})();
